export const FormHeader = () => <div className="margin-top-4">
    <h1 style={{
    fontWeight: 700,
    fontSize: '38px'
  }}>Välkommen med din ansökan om att bli spel- eller lottombud</h1>
    <p>
      Tillsammans med oss på Svenska Spel ser vi till att våra kunder kan spela på ett tryggt, säkert och glädjefullt sätt.
      <br />
      Vi skapar hållbara spelupplevelser som bidrar till ett bättre Sverige för alla.
      <br />
      <br />
      Välkommen med din ansökan!
      <br />
      <br />
      <span className="text-color">
        Stjärna (*) indikerar obligatoriska fält
      </span>
    </p>
  </div>;